module.exports = __webpack_public_path__ + "static/media/addIcon.09fb60ae.svg";